import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

const defaultData: IDataLayer = {
  event_name: 'cart_sample_added',
  event_category: 'viewcart',
  event_action: 'cart_sample_added',
  event_label: null // <sample name - SKU ID - sample category>
};

function trackSamplesAdded(_: string, eventData: IDataLayer = {}) {
  const selectedProductsList: string[] = [];
  if (eventData && eventData.sample_product_sku) {
    for (let i = 0; i < eventData.sample_product_name.length; i++) {
      selectedProductsList.push(
        tealium.dataLayer.formatProductEventLabel({
          product_name: [eventData.sample_product_name[i]],
          product_id: [`SKU${eventData.sample_product_sku[i]}`]
        })
      );
    }
    eventData.event_label = selectedProductsList.join();
  }
  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler('checkoutSampleAdded', trackSamplesAdded);
